import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const ATLAS_REQUEST_HEADER = 'X-Atlas-Request';

export class AtlasUnauthorizedError extends Error {
  constructor(public readonly httpError: HttpErrorResponse) {
    super('Atlas request was unauthorized.');
  }
}

@Injectable()
export class AtlasUnauthorizedHttpInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isAtlasRequest = request.headers.has(ATLAS_REQUEST_HEADER);
    const requestWithoutInternalHeaders = isAtlasRequest
      ? request.clone({ headers: request.headers.delete(ATLAS_REQUEST_HEADER) })
      : request;

    return next.handle(requestWithoutInternalHeaders).pipe(
      catchError(error => {
        if (isAtlasRequest && error instanceof HttpErrorResponse && error.status === 401) {
          return throwError(() => new AtlasUnauthorizedError(error));
        }

        return throwError(() => error);
      })
    );
  }
}

export const AtlasUnauthorizedHttpInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AtlasUnauthorizedHttpInterceptor,
  multi: true
};
